module.exports = __webpack_public_path__ + "static/media/corporateBuildingBig.f1c4c28e.svg";